import { render, staticRenderFns } from "./mCourseList.vue?vue&type=template&id=1b23aa42&"
import script from "./mCourseList.vue?vue&type=script&lang=js&"
export * from "./mCourseList.vue?vue&type=script&lang=js&"
import style0 from "./mCourseList.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports